import { ConnectorChannelIcon } from "#components/ui/ConnectorChannelIcon.tsx";
import { Channel } from "#features/channels/components/channels-details/Channel.tsx";
import { channels } from "#features/conversations/types/channels.tsx";
import { useSharedTranslation } from "#hooks/useSharedTranslation.ts";
import { Flex, Text } from "@hopper-ui/components";

export const OfficevibeChannel = () => {
    const { tShared } = useSharedTranslation();
    const { nameKey } = channels["WorkleapOfficevibe"];

    return (
        <Channel
            icon={<ConnectorChannelIcon type="WorkleapOfficevibe" />}
            title={tShared(nameKey)}
        >
            <Flex direction="column" gap="inline-sm">
                <Text size="xs" color="neutral-weak">
                    {tShared("workleapOfficevibeEngagementScores")}
                </Text>
                <Text size="xs" color="neutral-weak">
                    {tShared("workleapOfficevibeRecognition")}
                </Text>
                <Text size="xs" color="neutral-weak">
                    {tShared("workleapOfficevibeFeedback")}
                </Text>
                <Text size="xs" color="neutral-weak">
                    {tShared("workleapOfficevibeOneOnOneAgenda")}
                </Text>
            </Flex>
        </Channel>
    );
};
